import { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import { Button } from '../../components/ui/button'
import { Input } from '../../components/ui/input'
import { Card } from '../../components/ui/card'
import { useToast } from '../../hooks/use-toast'
import { Alert, AlertDescription } from '../../components/ui/alert'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [formError, setFormError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const { toast } = useToast()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setFormError('')
    setIsLoading(true)
    try {
        const resetUrl = `${window.location.origin}/#/auth/reset-password`

        console.log('Using direct reset URL:', resetUrl)

        const { error } = await supabase.auth.resetPasswordForEmail(
          email,
          {
            redirectTo: resetUrl
          }
          )

      if (error) throw error
      setIsSuccess(true)
      toast({
        title: 'Success',
        description: 'Password reset instructions have been sent to your email',
      })
    } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to send reset email'
      setFormError(errorMessage)
      toast({
        title: 'Error',
        description: errorMessage,
        variant: 'destructive',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="flex h-screen w-full items-center justify-center bg-black" style={{ fontFamily: 'Text md/Semibold, sans-serif', fontSize: '14px' }}>
      <Card className="w-full max-w-md p-8 bg-[#121212] text-[#CECFD2] border-0 shadow-xl">
        <div className="flex justify-center mb-6">
          <img src="/logo.png" alt="Club Logo" className="h-12" />
        </div>
        <h1 className="mb-6 text-2xl font-semibold text-center text-[#CECFD2]">Reset Password</h1>
        {isSuccess ? (
          <div className="space-y-5">
            <Alert className="bg-[#26222E] border-0 text-[#CECFD2]">
              <AlertDescription>
                Check your email for the password reset link. The link will expire in 1 hour.
              </AlertDescription>
            </Alert>
            <Link to="/login" className="block w-full">
              <Button
                type="button"
                className="w-full bg-[#26222E] hover:bg-[#342d3d] text-[#CECFD2] font-semibold h-12"
              >
                Back to Login
              </Button>
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
                className="w-full bg-[#26222E] border-0 text-[#CECFD2] placeholder:text-gray-500 h-12"
              />
            </div>
            {formError && (
              <Alert variant="destructive">
                <AlertDescription>{formError}</AlertDescription>
              </Alert>
            )}
            <Button
              type="submit"
              className="w-full bg-[#26222E] hover:bg-[#342d3d] text-[#CECFD2] font-semibold h-12"
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send Reset Instructions'}
            </Button>
            <div className="text-center">
              <Link to="/login" className="text-sm text-[#CECFD2] hover:text-gray-300">
                Back to Login
              </Link>
            </div>
          </form>
        )}
      </Card>
    </div>
  )
}
